import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "common-layout"
}
const _hoisted_2 = { class: "product-info" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "售价", -1)
const _hoisted_4 = {
  class: "right",
  style: {"color":"red","font-size":"25px"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "花语", -1)
const _hoisted_6 = { class: "right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "材料", -1)
const _hoisted_8 = { class: "right" }
const _hoisted_9 = { style: {"border-bottom":"1px solid #e7ebef"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "包装", -1)
const _hoisted_11 = { class: "right" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "配送说明", -1)
const _hoisted_13 = { class: "right" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { id: "code" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h5", { style: {"margin-top":"83px"} }, "热销推荐", -1)
const _hoisted_16 = { class: "product-recommend" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "韩式系列/公主的假日", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "￥239", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "韩式系列/公主的假日", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "￥239", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "韩式系列/公主的假日", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, "￥239", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, "韩式系列/公主的假日", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, "￥239", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, "韩式系列/公主的假日", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, "￥239", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", null, "韩式系列/公主的假日", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, "￥239", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", null, "韩式系列/公主的假日", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, "￥239", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, "韩式系列/公主的假日", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", null, "￥239", -1)
const _hoisted_33 = { class: "product-content" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h3", null, "商品详情", -1)

import { ref, onMounted } from 'vue'
import { getFlowers } from '../http/index'
// import { CreatePayUrlByCao919 } from '../http/paycenter'

import { useRouter } from 'vue-router'
// import  QRCode from 'qrcodejs2-fix' 


export default /*#__PURE__*/_defineComponent({
  __name: 'FlowerDetail',
  setup(__props) {

const path = ref('/loveflower');
//解析URL参数
let type = window.location.href.split('type=')[1];
switch (type) {
    case "1":
        path.value = '/loveflower'
        break;
    case "2":
        path.value = '/birthdayflower'
        break;
    case "3":
        path.value = '/friendflower'
        break;
    case "4":
        path.value = '/weddingflower'
        break;
}
const isShow = ref(false);
const info = ref()
let parms = {
    Id: 0,
    Type: type
}

// let parmsprice = {
//     price: 1 
// }


onMounted(async () => {
    let urls = window.location.href.match(/id=(\S*)&type=/);
    if (urls != null) {
        parms.Id = parseInt(urls[1])
    }
    info.value = (await getFlowers(parms)).data.result[0]
    isShow.value = true;

    // console.log(parmsprice.price );
    // // qrcodeimg.value= (await CreatePayUrlByCao919(parmsprice.Id)).data as any
    // const res = (await CreatePayUrlByCao919(parmsprice.price)).data as any;
    // console.log(res);
    // let qrcode  = new QRCode('code', {
    //     width: 100,// 二维码的宽
    //     height: 100,// 二维码的高
    //     text: res.value ? res.value : '', // 二维码的内容
    //     colorDark: '#000',// 二维码的颜色
    //     colorLight: '#fff',
    //     correctLevel: QRCode.CorrectLevel.H 
    // });
    // console.log(qrcode); 
})
const router = useRouter();
const goToPay = async () => {
    router.push({ path: '/pay', query: { id: parms.Id, type: parms.Type } });
}

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (isShow.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_breadcrumb, { separator: "/" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
                      default: _withCtx(() => [
                        _createTextVNode("首页")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_breadcrumb_item, {
                      to: { path: path.value }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("列表页")
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_el_breadcrumb_item, null, {
                      default: _withCtx(() => [
                        _createTextVNode("详情页")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_aside, { width: "500px" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, {
                      class: "bigImage",
                      src: info.value.bigImage
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_main, null, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", _hoisted_2, [
                      _createElementVNode("li", null, [
                        _createElementVNode("h3", null, _toDisplayString(info.value.title), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("span", null, _toDisplayString(info.value.description), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_3,
                        _createElementVNode("span", _hoisted_4, "￥" + _toDisplayString(info.value.price), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_5,
                        _createElementVNode("span", _hoisted_6, _toDisplayString(info.value.language), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_7,
                        _createElementVNode("span", _hoisted_8, _toDisplayString(info.value.material), 1)
                      ]),
                      _createElementVNode("li", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("span", _hoisted_11, _toDisplayString(info.value.packing), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_12,
                        _createElementVNode("span", _hoisted_13, _toDisplayString(info.value.deliveryRemarks), 1)
                      ])
                    ]),
                    _hoisted_14,
                    _createVNode(_component_el_button, {
                      type: "warning",
                      round: "",
                      onClick: goToPay
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("立即购买")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_aside, { width: "240px" }, {
              default: _withCtx(() => [
                _hoisted_15,
                _createElementVNode("ul", _hoisted_16, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_el_image, { src: "/images/content/a1.jpg" }),
                    _hoisted_17,
                    _hoisted_18
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_el_image, { src: "/images/content/a2.jpg" }),
                    _hoisted_19,
                    _hoisted_20
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_el_image, { src: "/images/content/a3.jpg" }),
                    _hoisted_21,
                    _hoisted_22
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_el_image, { src: "/images/content/a4.jpg" }),
                    _hoisted_23,
                    _hoisted_24
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_el_image, { src: "/images/content/a5.jpg" }),
                    _hoisted_25,
                    _hoisted_26
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_el_image, { src: "/images/content/a6.jpg" }),
                    _hoisted_27,
                    _hoisted_28
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_el_image, { src: "/images/content/a7.jpg" }),
                    _hoisted_29,
                    _hoisted_30
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_el_image, { src: "/images/content/a8.jpg" }),
                    _hoisted_31,
                    _hoisted_32
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createVNode(_component_el_image, { src: "/images/detail/content/by_1.jpg" }),
                  _createVNode(_component_el_image, { src: "/images/detail/content/by_2.jpg" }),
                  _createVNode(_component_el_image, { src: "/images/detail/content/by_3.jpg" }),
                  _createVNode(_component_el_image, { src: "/images/detail/content/by_4.jpg" }),
                  _createVNode(_component_el_image, { src: "/images/detail/content/by_5.jpg" }),
                  _createVNode(_component_el_image, { src: "/images/detail/content/by_6.jpg" })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})